<div class="bo-dialog">
<header class="bo-dialog__head"><span class="bo-dialog__icon"><i class="bi bi-file-earmark-text" aria-hidden="true"></i></span><div class="bo-dialog__heading"><h2 id="terms-title">{{ 'auth_terms_conditions' | translate }}</h2></div><button type="button" class="bo-dialog__close" (click)="activeModal.dismiss()" [attr.aria-label]="'ac_close' | translate"><i class="bi bi-x-lg" aria-hidden="true"></i></button></header>
<div class="bo-dialog__body bo-dialog__legal"><p><strong>{{ 'terms.p1_title' | translate }}</strong></p>
          <p>{{ 'terms.p1' | translate }}</p>

          <p><strong>{{ 'terms.use_license_title' | translate }}</strong></p>
          <p>{{ 'terms.use_license_intro' | translate }}</p>
          <ul>
            <li *ngFor="let li of useLicenseItems">{{ li }}</li>
          </ul>

          <p><strong>{{ 'terms.p3_title' | translate }}</strong></p>
          <p>{{ 'terms.p3' | translate }}</p>

          <p><strong>{{ 'terms.p4_title' | translate }}</strong></p>
          <p>{{ 'terms.p4' | translate }}</p>

          <p><strong>{{ 'terms.p5_title' | translate }}</strong></p>
          <p>{{ 'terms.p5' | translate }}</p>

          <p><strong>{{ 'terms.p6_title' | translate }}</strong></p>
          <p>{{ 'terms.p6' | translate }}</p>

          <p><strong>{{ 'terms.p7_title' | translate }}</strong></p>
          <p>{{ 'terms.p7' | translate }}</p>

          <p><strong>{{ 'terms.p8_title' | translate }}</strong></p>
          <p>{{ 'terms.p8' | translate }}</p>

          <p><strong>{{ 'terms.p9_title' | translate }}</strong></p>
          <p>{{ 'terms.p9' | translate }}</p>

          <p><strong>{{ 'terms.p10_title' | translate }}</strong></p>
          <p [innerHTML]="'terms.p10' | translate"></p>

</div>
<footer class="bo-dialog__foot"><button type="button" class="bo-dialog__button" (click)="activeModal.dismiss()">{{ 'ac_close' | translate }}</button></footer>
</div>
